import type { Bonus, PreviewPage, Volume } from '../types/content';
export const capabilities = ['Saber qué vas a comer antes de que llegue la hora de decidir', 'Comprar solamente lo que necesitás para tu planificación', 'Aprovechar una sesión de cocina para adelantar varias comidas', 'Abrir el freezer y encontrar opciones listas para usar'];
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'PLAN SEMANAL RESUELTO™',
  subtitle: 'Recibís semanas ya organizadas para empezar con todo resuelto.',
  items: ['Recibís semanas de comidas ya organizadas', 'Tenés listas de compras preparadas para cada plan', 'Contás con cantidades y porciones ya orientadas', 'Seguís sesiones de preparación paso a paso', 'Tenés planes de emergencia listos para días complicados'],
  result: '“Tengo un plan.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'COCINA POR TANDAS™',
  subtitle: 'Sesiones de cocina ya organizadas para adelantar varias comidas en una sola tanda.',
  items: ['Seguís sesiones de cocina ya organizadas', 'Usás combinaciones ya definidas de proteínas, bases y vegetales', 'Tenés el orden de producción definido', 'Aplicás un sistema de porcionado y guardado listo para usar', 'Cocinás desde cero muchas menos veces'],
  result: '“Tengo las comidas preparadas.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'FREEZER INTELIGENTE™',
  subtitle: 'Un sistema listo para convertir tu freezer en una reserva de comidas organizada.',
  items: ['Usás un sistema de zonas y categorías ya definido', 'Aplicás un método claro de etiquetado', 'Seguís una estructura de organización lista para usar', 'Contás con un sistema de rotación', 'Sabés de un vistazo qué usar primero'],
  result: '“Sé qué tengo, dónde está y qué debería usar.”',
  accent: 'highlight'
}, {
  label: 'VOLUMEN 04',
  title: 'SEMANA RESUELTA™',
  subtitle: 'Semanas ya armadas para llevar todo el sistema a tu rutina real.',
  items: ['Recibís semanas ya armadas para implementar', 'Tenés alternativas económicas listas', 'Contás con opciones para días con poco tiempo', 'Accedés a planes para viandas y semanas express', 'Contás con estructuras semanales reutilizables para no empezar de cero'],
  result: '“Tengo una semana lista para implementar.”',
  accent: 'danger'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/qDT1De1zeMa5Kos7ufRMHs/Hoja_1.webp',
  alt: 'Página del pack: Una comida completa puede salir de 4 componentes.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/989eL9Rrv1hpcj2jVUtaiG/Hoja_2.webp',
  alt: 'Página del pack: 2+2+2 para dejar de cocinar desde cero.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pCkUtT4vBxK6kTxE4xapet/Hoja_3.webp',
  alt: 'Página del pack: Porcioná antes de guardar.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tFZGFFjG9uTYC3rmJym6Sr/Hoja_4.webp',
  alt: 'Página del pack: Porcionar es comprarte tiempo.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'MAPA DEL FREEZER™',
  detail: 'Tu referencia visual rápida para encontrar lo que ya tenés guardado y saber qué usar primero.',
  items: ['Ubicás rápidamente cada tipo de preparación', 'Seguís zonas ya definidas según el alimento', 'Identificás qué conviene usar primero', 'Visualizás porciones disponibles de un vistazo', 'Hacés revisiones rápidas sin reorganizar todo el freezer'],
  value: '$12.000'
}, {
  number: '02',
  title: 'LISTA DE COMPRAS INTELIGENTE™',
  detail: 'Listas ya organizadas para pasar del menú a la compra sin empezar desde cero.',
  items: ['Usás listas preparadas por categorías', 'Tenés cantidades prácticas ya orientadas', 'Revisás primero lo que ya está disponible', 'Contás con sustituciones para ingredientes habituales', 'Comprás en función de las comidas que vas a preparar'],
  value: '$10.000'
}, {
  number: '03',
  title: 'DOMINGO DE COCINA™',
  detail: 'Un protocolo cronometrado para ejecutar tu sesión de preparación sin preguntarte qué hacer primero.',
  items: ['Seguís sesiones de 60 y 90 minutos ya estructuradas', 'Tenés el orden de producción definido', 'Sabés qué tareas hacer en paralelo', 'Pasás de ingredientes a porciones siguiendo una secuencia', 'Terminás con las preparaciones listas para guardar'],
  value: '$9.000'
}, {
  number: '04',
  title: 'KIT ANTI-DESPERDICIO™',
  detail: 'Planes de rescate listos para aprovechar alimentos, sobras y pequeñas cantidades.',
  items: ['Sabés qué alimentos priorizar primero', 'Usás combinaciones ya pensadas', 'Transformás sobras en nuevas preparaciones', 'Rescatás ingredientes que necesitan usarse pronto', 'Aprovechás mejor lo que ya compraste'],
  value: '$11.000'
}, {
  number: '05',
  title: 'PLAN SALVAVIDAS™',
  detail: 'Opciones rápidas ya pensadas para resolver la comida cuando la semana se complica.',
  items: ['Tenés alternativas de 5, 10 y 15 minutos', 'Usás combinaciones rápidas con lo que ya preparaste', 'Contás con opciones para días sin tiempo', 'Tenés soluciones para cuando no querés cocinar', 'Mantenés un stock mínimo de emergencia ya definido'],
  value: '$10.000'
}];
